import { useState, useRef, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import ToastMessage from "../../../utils/mui/righttoptoast";

// ✅ Custom styled calendar
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  borderRadius: "13px",
  boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
  backgroundColor: "#fff",
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: "#1D2951",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1D2951",
    },
  },
}));

const UserDetailsForm = ({ formData,setFormData,
            setScreen}) => {


  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("info");
  const [openToast, setOpenToast] = useState(false);

  const calendarRef = useRef(null);
  const handleCloseToast = () => setOpenToast(false);

  // ✅ Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setIsCalendarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Update form data dynamically
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

const handleDateChange = (newDate) => {
  if (newDate && dayjs(newDate).isValid()) {
    setFormData((prev) => ({
      ...prev,
      dob: newDate.toISOString(), // ✅ store as ISO string
    }));
  }
  setIsCalendarOpen(false);
};


  // ✅ Validation
  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.username.trim() || formData.username.length < 3) {
      setToastMessage("Username must be at least 3 characters long.");
      setToastSeverity("error");
      setOpenToast(true);
      return false;
    }
    if (!emailRegex.test(formData.email)) {
      setToastMessage("Please enter a valid email address.");
      setToastSeverity("error");
      setOpenToast(true);
      return false;
    }
    if (!phoneRegex.test(formData.phone)) {
      setToastMessage("Phone number must be 10 digits.");
      setToastSeverity("error");
      setOpenToast(true);
      return false;
    }
    if (!formData.dob) {
      setToastMessage("Please select your date of birth.");
      setToastSeverity("error");
      setOpenToast(true);
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
    setScreen(1)
    }
  };

  return (
    <div
      className="w-full max-w-screen-md h-auto bg-white text-start border p-6 relative"
      style={{
        borderRadius: "12.75px",
        boxShadow: "0 0 4px 0 rgba(179, 67, 67, 0.5)",
        borderColor: "rgba(179, 67, 67, 0.2)",
      }}
    >
      <h2 className="text-center text-xl font-semibold text-[#0A0A0A]">
        User Information
      </h2>
      <p className="text-center text-sm text-[#717182] mb-4">
        Please enter your details below
      </p>

      {/* Username */}
      <div className="mb-4">
        <label className="block font-semibold mb-2 text-[#0A0A0A]">
          Username
        </label>
        <input
          type="text"
          value={formData.username}
          onChange={(e) => handleChange("username", e.target.value)}
          placeholder="Enter your name"
          className="w-full px-3 py-2 border rounded-md focus:outline-none bg-[#F3F3F5]"
        />
      </div>     {/* DOB */}
      <div className="mb-4 relative">
        <label className="block font-semibold mb-2 text-[#0A0A0A]">
          Date of Birth
        </label>
    <input
  type="text"
  value={
    formData.dob && dayjs(formData.dob).isValid()
      ? dayjs(formData.dob).format("DD/MM/YYYY")
      : ""
  }
  onClick={() => setIsCalendarOpen(!isCalendarOpen)}
  placeholder="Select DOB"
  readOnly
  className="w-full px-3 py-2 border rounded-md bg-[#F3F3F5] cursor-pointer"
/>


        {/* Calendar */}
        {isCalendarOpen && (
          <div
            ref={calendarRef}
            className="absolute top-1/4 lg:top-28 right-0 z-10 bg-white shadow-md rounded-lg"
          >
         <LocalizationProvider dateAdapter={AdapterDayjs}>
  <CustomDateCalendar
    value={formData.dob ? dayjs(formData.dob) : null} // ✅ handle null safely
    onChange={handleDateChange}maxDate={dayjs()} // ✅ blocks all future dates
  />
</LocalizationProvider>

          </div>
        )}
      </div>

      {/* Email */}
      <div className="mb-4">
        <label className="block font-semibold mb-2 text-[#0A0A0A]">Email</label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
          placeholder="Enter your email"
          className="w-full px-3 py-2 border rounded-md focus:outline-none bg-[#F3F3F5]"
        />
      </div>

      {/* Phone Number */}
      <div className="mb-4">
        <label className="block font-semibold mb-2 text-[#0A0A0A]">
          Phone Number
        </label>
        <input
          type="text"
          value={formData.phone}
          onChange={(e) =>
            handleChange(
              "phone",
              e.target.value.replace(/\D/g, "").slice(0, 10)
            )
          }
          placeholder="Enter 10-digit phone number"
          className="w-full px-3 py-2 border rounded-md focus:outline-none bg-[#F3F3F5]"
        />
      </div>

 

      {/* Submit */}
      <button
        className="w-full sm:h-[40px] bg-[#0A0A0A] hover:bg-black text-white font-medium py-2 px-4 rounded"
        onClick={handleSubmit}
      >
   Next
      </button>

      {/* Toast Message */}
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleCloseToast}
      />
    </div>
  );
};

export default UserDetailsForm;
